import React, { useEffect, useState, useRef } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import CreatableSelect from 'react-select/creatable';
import Modal from '../../common/Modal';
import Form from './Form'
import { Student, Educator } from '../../../models/_models'
import 'react-toastify/dist/ReactToastify.css'
import styles from './Form.module.sass'
import ReactDOM from "react-dom";
import Spinner from "../../Spinner";
import Grid from '../../Grid';
import Button from '../../Button'

const InlineSelect = ({ studentId, attributeName, attributeValue, options,
                        useModal = false,
                        textAlign = '',
                        saveMessage = undefined,
                        setTeacherId = undefined,
                        selectValue = true,
                        refreshOnChange = false,
                        educatorId = undefined,
                        schoolId = undefined,
                        defaultText = undefined }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [currentStudent, setCurrentStudent] = useState();
  const [currentAttributeValue, setCurrentAttributeValue] = useState(attributeValue);
  const optionsForSelect = () => {
    if (!options) return [];

    return [{ label: 'Remove from class', value: '' }, ...options]
  }
  const [teachers, setTeachers] = useState(optionsForSelect())
  const inputRef = useRef(null);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  useEffect(() => {
    if (currentStudent) return;
    if (!isEditing && !useModal) return;

    Student.find(studentId).then((res) => {
      setCurrentStudent(res.data)
    })
  }, [isEditing]);

  useEffect(() => {
    if (!inputRef.current) return;

    inputRef.current.focus();
  }, [inputRef.current])

  const handleClick = () => {
    if (useModal) {
      openModal();
    } else {
      setIsEditing(true);
    }
  }

  const handleEdit = () => {
    closeModal();
    setIsEditing(true);
  }

  const handleBlur = () => {
    setIsEditing(false);
  }

  const removeStudent = () => {
    if (!currentStudent) return

    currentStudent.attributes = { ...currentStudent.attributes,
      ...{ teacher: `Removed - ${educatorId}`} }

    currentStudent
      .save()
      .then(() => {
        toast('Student was updated successfully', { containerId: studentId })
        closeModal()

        if (refreshOnChange) {
          $('#students-composite').html('');
          ReactDOM.render(<Spinner color="blue" />, $('#students-composite')[0])

          $.ajax({
            url: `/schools/${schoolId}/refresh.js?teacher_id=${educatorId}`,
            data: { educator_id: educatorId },
            type: 'POST',
            dataType: 'script',
          })
        }
      })
      .catch(() => {
        toast.error('There was an error saving the student', { containerId: studentId })
        setIsEditing(false)
      })
  }

  const handleSubmit = (newValue) => {
    if (!currentStudent) return

    currentStudent.attributes = { ...currentStudent.attributes,
      ...{ [attributeName]: newValue } }

    currentStudent
      .save()
      .then(() => {
        setCurrentAttributeValue(newValue)
        toast(saveMessage || 'Student was updated successfully', { containerId: studentId })
        setIsEditing(false)

        if (setTeacherId) {
          setTeacherId(newValue);
        }

        if (refreshOnChange) {
          $('#students-composite').html('');
          ReactDOM.render(<Spinner color="blue" />, $('#students-composite')[0])

          $.ajax({
            url: `/schools/${schoolId}/refresh.js?teacher_id=${educatorId}`,
            data: { educator_id: educatorId },
            type: 'POST',
            dataType: 'script',
          })
        }
      })
      .catch(() => {
        toast.error('There was an error saving the student', { containerId: studentId })
        setIsEditing(false)
      })
  }

  const teacherName = () => (
    teachers.find(s => s.value === currentAttributeValue)
  )

  const handleCreate = async (name) => {
    let teacher = null;

    await Educator
      .where({ schoolId: currentStudent.schoolId, name: name })
      .all()
      .then((res) => {
        if (res.data.length > 1) {
          teacher = res.data[0];
          setTeachers({ ...teachers, value: teacher.id, label: name })
          handleSubmit(teacher.id)
        } else {
          const newTeacher = new Educator({
            name: name,
            schoolId: currentStudent.schoolId
          })

          newTeacher.save().then(() => {
            teacher = newTeacher;
            setTeachers([...teachers, { value: teacher.id, label: name }])
            handleSubmit(teacher.id)
          })
        }
      })
  }

  const renderLink = () => {
    if (isEditing) {
      return (
        <Form
          onSubmit={handleSubmit}>
          <div style={{ fontSize: '12px' }}>
            <CreatableSelect
              openMenuOnFocus
              autofocus
              ref={inputRef}
              onCreateOption={handleCreate}
              onChange={(e) => handleSubmit(e.value)}
              options={teachers}
              value={selectValue && teacherName()}
              onBlur={handleBlur}
              placeholder="Select teacher (type to enter)" />
          </div>
        </Form>
      )
    }

    return (
      <>
        <Modal
          modalIsOpen={isOpen}
          closeModal={closeModal}
          contentLabel='Move or remove student'
          headerText='Move or remove student'
        >
          <Grid container>
            <Grid xs={3} />
            <Grid container item direction='column' justify='center' alignItems='center' xs={2}>
              <Button classes={styles.removeButton} onClick={removeStudent}>
                Student is no longer enrolled
              </Button>
            </Grid>
            <Grid xs={2} />

            <Grid container item direction='column' justify='center' alignItems='center' xs={2}>
              <Button classes={styles.changeClassButton} onClick={handleEdit}>
                Move student to another classroom
              </Button>
            </Grid>
            <Grid xs={3} />
          </Grid>
        </Modal>
        <div onClick={useModal ? openModal : handleClick}
             style={{ textAlign: textAlign }}
             className={textAlign && styles.selectLabel}>
          {defaultText || (teacherName() && teacherName().label) || 'No data'}
        </div>
      </>
    )
  }

  return (
    <>
      <ToastContainer
        enableMultiContainer
        autoClose={2000}
        position="bottom-right"
        containerId={studentId}
      />

      {renderLink()}
    </>
  )
};

export default InlineSelect;
